<div class="procedures-list">
  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
    <h2>Actions en cours</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of inProgressProceduresList; track procedure) {
        <div class="col-12" (click)="getInProgressProcedure(procedure)">
          <app-procedure-card [icon]="'icons/procedures/customer/'+procedure.code+'.png'" [cursor]="true" [text]="procedure.label" [status]="procedure.status"></app-procedure-card>
        </div>
      }
    </div>
  }

  @if ((null == selectedProcedure || '' == selectedProcedure) && activeProceduresList.length > 0) {
    <h2>Actions disponibles</h2>
  }
  @if ((null == selectedProcedure || '' == selectedProcedure) && activeProceduresList.length > 0) {
    <div class="procedure-grid w-100 mb-4">
      @for (procedure of activeProceduresList; track procedure) {
        <div class="col-12" (click)="getProcedure(procedure)">
          <app-procedure-card [icon]="'icons/procedures/customer/'+procedure.code+'.png'" [cursor]="true" [text]="procedure.label" [status]="procedure.status"></app-procedure-card>
        </div>
      }
    </div>
  }
</div>
@if (constHelper.PROCEDURE_RESET_PASSWORD == selectedProcedure) {
  <app-update-password></app-update-password>
}
@if (constHelper.PROCEDURE_ACCOUNT_CONSOLIDATION == selectedProcedure) {
  <app-account-consolidation [procedureCode]="selectedProcedure" [step]="step" [status]="status" [message]="message"></app-account-consolidation>
}
@if (constHelper.PROCEDURE_GENERATE_SEPA_MANDATE == selectedProcedure) {
  <app-generate-sepa-mandate [procedureCode]="selectedProcedure"></app-generate-sepa-mandate>
}
@if (constHelper.PROCEDURE_UPDATE_IBAN == selectedProcedure) {
  <app-update-iban [procedureCode]="selectedProcedure" [message]="message"></app-update-iban>
}
@if (constHelper.PROCEDURE_EXPORT_BILLING_STATUS == selectedProcedure) {
  <app-export-billing-status [procedureCode]="selectedProcedure" [message]="message"></app-export-billing-status>
}
@if (constHelper.PROCEDURE_SIGNATORIES_MANAGEMENT == selectedProcedure) {
    <app-signatories-management [procedureCode]="selectedProcedure"></app-signatories-management>
}
